import React, { useContext } from 'react';
import _ from 'lodash';
import moment from 'moment-strftime';
import {graphql} from 'gatsby';

import {Layout} from '../components/index';
import Header from '../components/Header';
import {getPages, Link, withPrefix} from '../utils';
import Footer from '../components/Footer';
import { ThemeContext } from '../context/ThemeProvider';
import { VscColorMode } from 'react-icons/vsc';

// this minimal GraphQL query ensures that when 'gatsby develop' is running,
// any changes to content files are reflected in browser
export const query = graphql`
  query($url: String) {
    sitePage(path: {eq: $url}) {
      id
    }
  }
`;

export default function Posts(props) {

  let display_posts = _.orderBy(getPages(props.pageContext.pages, '/posts'), 'frontmatter.date', 'desc');

  const [mode] = useContext(ThemeContext)

  return (
      <Layout {...props}>
        <Header {...props} site={props.pageContext.site} page={props.pageContext} image={_.get(props, 'pageContext.site.siteMetadata.header.background_img', null)} />
        <div id="content" className="site-content">
          <main id="main" className="site-main inner">
            <p style={{
              backgroundColor: mode ? "#131415" : "#F4F5F7",
              color: mode ? "#fff" : "#000",
              padding: 10
            }}>🌱 This is not a blog, it is a digital garden/documentation of my life. A digital garden is a collection of thoughts, ideas and actions which signifies the process of evolution. Unlike blogs, a digital garden does not have a publish date, the posts are evergreen and keep evolving with sequels.</p>
            <br />
            <div className="post-feed">
              {_.map(display_posts, (post, post_idx) => (
              <article key={post_idx} className="post">
                <header className="post-header">
                  <h2 style={{
                    color: mode ? "#fff" : "#000"
                  }} className="post-title"><Link to={withPrefix(_.get(post, 'url', null))} rel="bookmark">{_.get(post, 'frontmatter.title', null)}</Link></h2>
                  <div className="post-meta">
                    Published on <time className="published"
                      dateTime={moment(_.get(post, 'frontmatter.date', null)).strftime('%Y-%m-%d %H:%M')}>{moment(_.get(post, 'frontmatter.date', null)).strftime('%B %d, %Y')}</time>
                  </div>
                </header>
                {_.get(post, 'frontmatter.thumb_img_path', null) && (
                <Link className="post-thumbnail" to={withPrefix(_.get(post, 'url', null))}>
                  <img className="thumbnail" src={withPrefix(_.get(post, 'frontmatter.thumb_img_path', null))} alt={_.get(post, 'frontmatter.title', null)} />
                </Link>
                )}
                <div className="post-content">
                  <p>{_.get(post, 'frontmatter.excerpt', null)}</p>
                </div>
                {((_.get(props, 'pageContext.frontmatter.has_more_link', null) === true) && _.get(props, 'pageContext.frontmatter.more_link_text', null)) && (
                <p className="read-more">
                  <Link className="read-more-link" to={withPrefix(_.get(post, 'url', null))}>{_.get(props, 'pageContext.frontmatter.more_link_text', null)} <span className="icon-arrow-right" aria-hidden="true" /></Link>
                </p>
                )}
              </article>
              ))}
            </div>
          </main>
          <Footer {...props} site={props.pageContext.site} page={props.pageContext} image={_.get(props, 'pageContext.site.siteMetadata.header.background_img', null)} />
        </div>
      </Layout>
  )
}
